class Table {
  constructor(config = {}) {
    this.name = config.name || 'Table';
    this.container = config.container;
    this.fields = config.fields;
    this.data = config.data || [];
    this.filteredData = config.filteredData || this.data;
    this.conditionalFormatting = config.conditionalFormatting;
    this.rowIndicatorFormatting = config.rowIndicatorFormatting;
    this.noDataMessage = config.noDataMessage || 'No Data';
    this.init();
  }

  toggleProgressSpinner() {
    const progressSpinner = document.querySelector(`${this.container} #progress-spinner-wrapper`);
    if ( progressSpinner !== null ) {
      progressSpinner.style.display = 'none';
    }
  }

  clearTable() {
    const table = document.querySelector(this.container);
    table.innerHTML = '';
    return this;    
  }

  createTable() {
    const table = document.createElement('table');
    const container = document.querySelector(this.container);
    table.classList += 'table table-striped colors-of-water-table';

    if (this.filteredData.length > 0) {
      const thead = this.createTableHeader();
      const tbody = this.createTableBody();

      table.appendChild(thead);
      table.appendChild(tbody);
      container.appendChild(table);
    } else {
      const container = document.querySelector(this.container);
      container.innerHTML = `<h3 class="text-center">${this.noDataMessage}</h3>`;
    }
    return this;
  }

  createTableHeader() {
    const thead = document.createElement('thead');
    const tr = document.createElement('tr');
    const fields = Object.keys(this.fields);

    if (typeof this.rowIndicatorFormatting !== 'undefined') {
      const th = document.createElement('th');
      tr.appendChild(th);
    }

    fields.forEach( field => {
      const th = document.createElement('th');
      th.textContent = this.fields[field];
      tr.appendChild(th);
    });

    thead.appendChild(tr);
    return tr;
  }

  createTableBody() {
    const tbody = document.createElement('tbody');
    const data = this.filteredData;
    const fields = Object.keys(this.fields);
    let conditionalField;
    let conditionalFieldValues;
    let rowIndicatorField;
    let rowIndicatorFieldValues;

    if (typeof this.conditionalFormatting !== 'undefined') {
      conditionalField = Object.keys(this.conditionalFormatting)[0];
      conditionalFieldValues = Object.keys(this.conditionalFormatting[conditionalField]);
    }

    if (typeof this.rowIndicatorFormatting !== 'undefined') {
      rowIndicatorField = Object.keys(this.rowIndicatorFormatting)[0];
      rowIndicatorFieldValues = Object.keys(this.rowIndicatorFormatting[rowIndicatorField]);
    }


    data.forEach( d => {
      const tr = document.createElement('tr');

      if (typeof this.conditionalFormatting !== 'undefined') {
        if (conditionalFieldValues.includes(d[conditionalField])) {
          const styleName = this.conditionalFormatting[conditionalField][d[conditionalField]].style.name;
          const styleValue = this.conditionalFormatting[conditionalField][d[conditionalField]].style.value;
          tr.style[styleName] = styleValue;
        }
      }

      if (typeof this.rowIndicatorFormatting !== 'undefined') {
        if (rowIndicatorFieldValues.includes(d[rowIndicatorField])) {
          const color = this.rowIndicatorFormatting[rowIndicatorField][d[rowIndicatorField]].color;
          const td = document.createElement('td');
          td.innerHTML = `<div class="row-indicator-dot" style="background-color: ${color}"></div>`;
          tr.appendChild(td);
        }
      }

      fields.forEach( field => {
        const td = document.createElement('td');
        td.innerHTML = d[field];
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    })
    return tbody;
  }

  build() {
    this.createTable();
    this.toggleProgressSpinner();
  }

  validateConfig() {
    const requiredProps = {
      container: this.container,
      fields: this.fields,
    }

    for ( let prop in requiredProps ) {
      if ( typeof this[prop] === "undefined" ) {
        throw `Error: ${this.name} could not be created. Please provide a value for the ${prop} property.`;
      }
    }
    return this;
  }

  init() {
    this.validateConfig();
  }
}
